module.exports = __webpack_public_path__ + "img/home-pages-header-icon.cd42f676.png";